import { RiskAssessmentResultControlType as Risk_Assessment_Result_Control_Type_Enum } from '@risksmart-app/domain/src/types/consts/risk-assessment-result-control-type';

/**
 * Maps a rating's ControlType to the analytics rating_type label
 * ('inherent' | 'residual'). Used for Amplitude event properties.
 */
export const mapControlTypeToRatingType = (
  controlType: Risk_Assessment_Result_Control_Type_Enum | undefined
): 'inherent' | 'residual' | undefined => {
  if (controlType === Risk_Assessment_Result_Control_Type_Enum.Uncontrolled) {
    return 'inherent';
  }
  if (controlType === Risk_Assessment_Result_Control_Type_Enum.Controlled) {
    return 'residual';
  }

  return undefined;
};
